import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTeams } from '../../contexts/TeamsContext';
import { OnboardingStatusEnum } from 'api-client';

// List of paths that should be accessible even if onboarding is not completed
const ALLOWED_PATHS = ['/onboarding', '/signout'];

export const OnboardingRedirect = ({ children }: { children: React.ReactNode }) => {
  const { currentTeam, isLoading } = useTeams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect while teams are loading
    if (isLoading || !currentTeam) {
      return;
    }

    // If we're already on an allowed path, don't redirect
    if (ALLOWED_PATHS.some(path => location.pathname.startsWith(path))) {
      return;
    }

    // Check if onboarding is not completed
    const needsOnboarding = currentTeam.onboardingStatus !== OnboardingStatusEnum.Completed;
    
    if (needsOnboarding) {
      navigate('/onboarding', { replace: true });
    }
  }, [currentTeam, isLoading, location.pathname, navigate]);

  return <>{children}</>;
};

export default OnboardingRedirect;
